import {createUseStyles} from 'react-jss';
import MediaQueries from '../../v2/style-helper/MediaQueries';

const centeriseLogo = {
  display: 'block',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '50%',
};

const RTLLogo = {
  display: 'block',
  marginLeft: 'auto',
  marginRight: 0,
};

export default createUseStyles({
  header: {
    background: props => (props.isUsingArtemisStyles
      ? props.theme.patterns?.header?.backgroundColor || props.theme.header.backgroundColour
      : props.theme.header.backgroundColour),
  
    [MediaQueries.phone]: {
      background: props => (!props.isUsingArtemisStyles
        && (props.theme.header.mobileBackgroundColour || props.theme.header.backgroundColour)),
    },
  },
  container: {
    margin: '0 auto',
    maxWidth: 960,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: props => props.theme.header.padding,
    paddingBottom: props => props.theme.header.paddingBottom,
    paddingTop: props => (props.theme.header.paddingTop === 0 || props.theme.header.paddingTop)
      && props.theme.header.paddingTop,
    paddingLeft: props => (props.theme.header.paddingLeft === 0 || props.theme.header.paddingLeft)
      && props.theme.header.paddingLeft,
  
    [MediaQueries.phone]: {
      padding: props => props.theme.header.padding / 2,
    },
  },
  logoContainer: {
    [MediaQueries.tablet]: {
      width: props => (props.isRTL ? '100%' : (props.theme.header.width || '70%')),
    },
    
    [MediaQueries.phone]: {
      width: '100%',
    },
  },
  link: {
    display: 'block',
  },
  logo: {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: props => props.isRTL && 'right',
    height: props => ((props.isUsingArtemisStyles && props.theme.patterns?.header?.headerLogo?.desktop)
      ? props.theme.patterns.header.headerLogo.desktop.height
      : props.theme.header.logoHeight),
    marginTop: props => (props.theme.header.marginTop === 0 || props.theme.header.marginTop)
      && props.theme.header.marginTop,
    marginBottom: props => props.theme.header.marginBottom,
    extend: props => ({
      ...(props.isUsingArtemisStyles && props.isRTL) && RTLLogo,
    }),
    
    [MediaQueries.phone]: {
      backgroundPosition: props => (props.isRTL && props.theme.header.mobileLogoPlacement === 'left'
        ? 'right' : props.theme.header.mobileLogoPlacement),
      height: props => ((props.isUsingArtemisStyles && props.theme.patterns?.header?.headerLogo?.mobile)
        ? props.theme.patterns.header.headerLogo.mobile.height
        : props.theme.header.mobileLogoHeight || props.theme.header.logoHeight),
      // Need margin attribute separated so centeriseLogo can override marginLeft and Right
      marginTop: props => (props.theme.header.mobileMargin === 0 || props.theme.header.mobileMargin)
        && props.theme.header.mobileMargin,
      marginBottom: props => (props.theme.header.mobileMargin === 0 || props.theme.header.mobileMargin)
        && props.theme.header.mobileMargin,
      marginLeft: props => (props.theme.header.mobileMargin === 0 || props.theme.header.mobileMargin)
        && props.theme.header.mobileMargin,
      marginRight: props => (props.theme.header.mobileMargin === 0 || props.theme.header.mobileMargin)
        && props.theme.header.mobileMargin,
      extend: props => ({
        ...(props.isUsingArtemisStyles && props.theme.header.mobileLogoPlacement === 'center') && centeriseLogo,
        ...(props.isUsingArtemisStyles && props.isRTL && props.theme.header.mobileLogoPlacement === 'left') && RTLLogo,
      }),
    },
  },
});
